import React from 'react';
import { usePWA } from '../pwa/PWAContext';
import './PWASettingsCard.css';

const PWASettingsCard = () => {
  const {
    isStandalone,
    canInstall,
    isIOS,
    installApp
  } = usePWA();

  return (
    <div className="pwa-settings-card">
      <h2>Aplicația ContaLearn</h2>

      <p className="pwa-settings-description">
        Instalează ContaLearn pe dispozitivul tău pentru acces rapid
        și o experiență similară unei aplicații.
      </p>

      {isStandalone && (
        <div className="pwa-settings-status pwa-settings-status-success">
          <strong>Aplicația este activă</strong>
          <span>
            Folosești ContaLearn în modul aplicație pe acest dispozitiv.
          </span>
        </div>
      )}

      {!isStandalone && canInstall && (
        <div className="pwa-settings-install">
          <strong>Instalează ContaLearn</strong>

          <span>
            Aplicația poate fi instalată din browserul pe care îl
            folosești acum.
          </span>

          <button
            type="button"
            className="pwa-settings-install-button"
            onClick={installApp}
          >
            Instalează aplicația
          </button>
        </div>
      )}

      {!isStandalone && !canInstall && isIOS && (
        <div className="pwa-settings-info">
          <strong>Instalează ContaLearn pe dispozitiv</strong>

          <span>
            Deschide meniul Partajare și selectează
            „Adaugă la ecranul principal”.
          </span>
        </div>
      )}

      {!isStandalone && !canInstall && !isIOS && (
        <div className="pwa-settings-info">
          <strong>Instalare din browser</strong>

          <span>
            În acest moment browserul nu oferă instalarea automată.
            Verifică și meniul browserului pentru opțiunea de instalare.
          </span>
        </div>
      )}
    </div>
  );
};

export default PWASettingsCard;